import { Utility } from 'src/app/shared/utility';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { State } from '@progress/kendo-data-query';
import { AdjustmentService } from 'src/app/shared/services/adjustments/adjustment.service';
import { HttpErrorResponse } from '@angular/common/http';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { UsersService } from 'src/app/shared/services/common/users.service';
import { SelectableSettings, DataBindingDirective } from '@progress/kendo-angular-grid';
import { DOCUMENT } from '@angular/common';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { CommonService } from 'src/app/shared/services/common/common.service';
import { ReadConfigService } from 'src/app/shared/services/common/read-config.service';

@Component({
  selector: 'app-adjustment-reports',
  templateUrl: './adjustment-reports.component.html',
  styleUrls: ['./adjustment-reports.component.css']
})

export class AdjustmentReportsComponent implements OnInit {
  @ViewChild(DataBindingDirective, { static: true }) directive;
  constructor(@Inject(DOCUMENT) private document: any,
    private adjustmentService: AdjustmentService,
    private authService: AuthService,
    private commonService: CommonService,
    private usersService: UsersService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService) { }

  gridView: any;
  systems = '';
  inputData: { userInfo: any; };
  selectedItem: any;
  adjRecordData: any;
  bankInfoExist: boolean;
  disableAddAdj = true;
  config: any;
  operators: any;
  adjSummaryRecords: any;
  filterRows: any;
  recordSelected: any;
  adjDeleteDialog: boolean;
  displayload: boolean;
  createAdjBtnFlag: boolean;
  contributionWithheld: boolean;
  isCurrentFy: boolean;
  adjId: number;
  confirmOpen = false;
  isSelectedRowChanged = false;
  isChanged = false;
  skip = 0;
  take = 5;
  rowIndex = 0;
  selectableSettings: SelectableSettings = { mode: 'single' };
  gridState: State = {
    sort: [],
    take: this.take,
    skip: this.skip,
  };

  ngOnInit() {
    this.inputData = {
      userInfo: this.usersService.UserInfo()
    };
    this.loadAdjHistory();
    this.config = this.readConfigService.getAdjustmentFileUpload();
    this.operators = this.authService.getAccessOperations(2);
    this.contributionWithheld = true;
    this.isCurrentFy = false;
  }

  addHandler() {
    this.adjRecordData = { id: 0, system: JSON.parse(this.systems) };
    this.setSelectedRow(0, true, false, false, false);
    this.contributionWithheld = true;
    this.createAdjBtnFlag = false;
    this.disableAddAdj = true;
    this.isCurrentFy = true;
    this.adjSummaryRecords = null;
  }

  loadSystems(): void {
    this.notificationService.setUpLoading(true);
    this.commonService.getLocations()
      .subscribe(data => {
        if (data && data.systems) {
          const systems = data.systems;
          systems.forEach((item, index) => {
            item.id = +item.id;
            item.adjustmentAmount = 0.00;
            systems[index] = item;
          });
          this.systems = JSON.stringify(systems);
          this.operators.Add ? this.addHandler() : this.loadDefaultRcd();
        }
      },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.notificationService.setErrorNotification();
        });
  }

  loadDefaultRcd() {
    if (this.gridView && this.gridView.length > 0) {
      this.setSelectedRow(0, true, false, false, true);
    } else {
      this.notificationService.setUpLoading(false);
    }
  }

  loadAdjHistory() {
    this.notificationService.setUpLoading(true);
    this.adjustmentService.getAdjustmentHistory(this.inputData)
      .subscribe(response => {
        if (response && response.success) {
          this.bankInfoExist = response.bankInfoExist;
          const gridView = response.data;
          gridView.forEach(element => {
            element.submittedDate = Utility.formatDate(element.submittedDate);
          });
          this.gridView = gridView;
          this.directive.skip = 0;
          this.loadSystems();
        } else {
          this.notificationService.setErrorNotification();
          this.loadDefaultRcd();
        }
      },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.notificationService.setUpLoading(false);
          this.notificationService.setErrorNotification();
        });
  }

  loadAdjRecords(id): void {
    this.adjustmentService.getAdjustmentRecords(id, this.usersService.UserInfo())
      .subscribe(response => {
        if (response && response.success) {
          this.adjRecordData = { id, system: JSON.parse(response.data) };
        } else {
          this.notificationService.setErrorNotification();
        }
        this.notificationService.setUpLoading(false);
      },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.notificationService.setUpLoading(false);
          this.notificationService.setErrorNotification();
        });
  }

  loadAdjSummary(dataItem): void {
    if (dataItem) {
      this.adjSummaryRecords = dataItem;
    }
  }

  deleteAdjDialog(id: number) {
    this.adjId = id;
    this.adjDeleteDialog = true;
  }

  deleteAdj(status: any): void {
    if (status === 'yes') {
      this.displayload = true;
      this.notificationService.setUpLoading(true);
      this.adjustmentService.deleteAdjustment(this.adjId, this.usersService.UserInfo())
        .subscribe((response) => {
          if (response && response.success) {
            this.adjDeleteDialog = false;
            this.displayload = false;
            this.displayResult(response);
          } else {
            this.adjDeleteDialog = false;
            this.displayload = false;
            this.notificationService.setUpLoading(false);
            this.notificationService.setErrorNotification();
          }
        },
          (error: HttpErrorResponse) => {
            console.log(error);
            this.displayload = false;
            this.adjDeleteDialog = false;
            this.notificationService.setUpLoading(false);
            this.notificationService.setErrorNotification();
          });
    } else {
      this.adjDeleteDialog = false;
    }
  }

  recordSaved(response) {
    this.displayResult(response);
  }

  displayResult(response: any) {
    this.resetChanges(true, true);
    this.notificationService.setUpNotification(response);
  }

  pageChange(state: State): void {
    if (this.adjRecordData.id > 0) {
      this.skip = state.skip;
      this.take = state.take;
      setTimeout(() => {
        this.setSelectedRow(0, true, false, false, true);
      }, 100);
    }
  }

  cellClickHandler({ dataItem, isEdited }: any) {
    this.recordSelected = dataItem;
    if (this.createAdjBtnFlag) {
      this.confirmOpen = true;
    } else {
      this.disableAddAdj = false;
      if (!isEdited) {
        if (this.recordSelected) {
          this.createAdjBtnFlag = false;
          this.notificationService.setUpLoading(true);
          this.loadAdjRecords(dataItem.id);
          this.loadAdjSummary(dataItem);
          this.contributionWithheld = this.recordSelected.contributionWithheld;
          this.isCurrentFy = this.recordSelected.isCurrentFy;
        }
      }
      if (this.selectedItem !== dataItem) {
        this.isSelectedRowChanged = true;
        this.selectedItem = dataItem;
      } else {
        this.isSelectedRowChanged = true;
      }
    }
  }

  resetChanges(args: any, loadHistry = true): void {
    this.changeDDwnStage(args);
    this.createAdjBtnFlag = !args;
    if (args && loadHistry) {
      this.loadAdjHistory();
    }
  }

  changeDDwnStage(args: boolean) {
    this.isChanged = !args;
    this.authService.formChanged(args);
  }

  onCancelBtnClick(args: any) {
    if (args === 'yes') {
      this.adjRecordData = null;
      this.confirmOpen = true;
      this.resetChanges(true, false);
      if (this.recordSelected) {
        this.cellClickHandler({ dataItem: this.recordSelected, isEdited: false });
      } else {
        this.loadSystems();
      }
    }
    this.confirmOpen = false;
  }

  setSelectedRow(index: number, isManualSelection: any, isSelected: any, isCellClick: any, reqSelection: boolean = true) {
    if (!this.document ) { return; }
    const adjElem = this.document.getElementById('adjustment-history-grid');
    if (!adjElem) { return; }
    const grid = adjElem.getElementsByClassName('k-grid-content')[0];
    if (!grid) { return; }
    const filterRow = adjElem.getElementsByClassName('k-filter-row');
    if (filterRow && filterRow[0]) {
      const inputRows = filterRow[0].getElementsByTagName('input');
      if (inputRows) {
        this.filterRows = inputRows;
      }
    }

    const rows = grid.getElementsByTagName('tr');
    let dataRowIndex = -1;
    const selectedRow = grid.getElementsByClassName('k-state-selected')[0];
    for (const row of rows) {
      if (row.className.indexOf('k-grouping-row') < 0 && row.className.indexOf('k-group-footer') < 0) {
        if (isManualSelection) {
          this.rowIndex = 1;

          if (selectedRow != null) {
            selectedRow.className = String(selectedRow.className)
              .replace('k-state-selected', '')
              .replace('k-state-selected', '');
          }

          for (const childRow of row.children) {
            if (childRow.className.indexOf('k-group-cell') < 0 && childRow.children[0] != null) {
              if (reqSelection) {
                row.children[0].click();
                const v = grid.getElementsByTagName('tr')[0];
                v.className += 'k-state-selected';
              }
              break;
            }
          }
          break;
        } else {
          if (this.isSelectedRowChanged) {
            this.rowIndex = index + 1;
            return;
          }
          if (selectedRow == null) {
            row.className = row.className + ' k-state-selected';
            for (const childRow of row.children) {
              if (childRow.className.indexOf('k-group-cell') < 0 && childRow.children[0] != null) {
                if (reqSelection) { childRow.click(); }
                break;
              }
            }
            break;
          } else {
            dataRowIndex++;
            if (!this.isSelectedRowChanged) {
              break;
            } else {
              this.rowIndex = dataRowIndex + 1;
            }
          }

        }
      }
    }
  }

}
